import { Link, useLocation } from 'react-router-dom';
import { BookOpen, ChevronRight, HelpCircle } from 'lucide-react';
import { OrgSwitcher } from './OrgSwitcher';
import { useProject } from '../../hooks/useProjects';
import './TopBar.css';

function Docs() {
  return (
    <Link to="/docs" className="topbar__link">
      <BookOpen size={14} aria-hidden="true" />
      Docs
    </Link>
  );
}

function ProjectBreadcrumb() {
  const { pathname } = useLocation();
  const projectId = pathname.match(/^\/projects\/([^/]+)/)?.[1];
  const { data: project } = useProject(projectId);

  if (!projectId) return null;

  return (
    <>
      <ChevronRight size={14} className="topbar__breadcrumb-sep" aria-hidden="true" />
      <Link to={`/projects/${projectId}`} className="topbar__breadcrumb">
        {project?.name ?? '…'}
      </Link>
    </>
  );
}

export function TopBar() {
  return (
    <header className="topbar">
      <div className="topbar__left">
        <Link to="/" className="topbar__logo" aria-label="Pryma">
          <svg
            className="topbar__logo-mark"
            width="22"
            height="22"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
          >
            <path d="M11 4 L21 26 L1 26 Z" fill="#7C3AED" />
            <path d="M14 8 L22 26 L6 26 Z" fill="#06B6D4" />
          </svg>
          <span className="topbar__logo-wordmark">pryma.</span>
        </Link>
        <span className="topbar__divider" aria-hidden="true" />
        <OrgSwitcher />
        <ProjectBreadcrumb />
      </div>
      <div className="topbar__right">
        <Docs />
        <button type="button" className="topbar__link">
          <HelpCircle size={14} aria-hidden="true" />
          Help
        </button>
      </div>
    </header>
  );
}
